import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TablePagination,
  useTheme,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { FC, MouseEvent, useState } from 'react';
import { Tag, TagKind, WbTag } from './WbTag';

interface WbTagsModalProps {
  open: boolean;
  onClose: () => void;
  tags: Array<Tag>;
  kind?: TagKind;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg';
}

// deprecated
export const WbTagsModal: FC<WbTagsModalProps> = ({
  maxWidth = 'sm',
  open,
  onClose,
  tags,
  kind = TagKind.generic,
}) => {
  const theme = useTheme();
  const [page, setPage] = useState(0);
  const handleChange = (_event: MouseEvent | null, value: number) => {
    setPage(value);
  };

  return (
    <Dialog
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 1,
          backgroundColor: theme.palette.background.default,
        },
      }}
      open={open}
      onClose={onClose}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <DialogTitle>
        Tags
        <IconButton
          size="small"
          aria-label="close"
          onClick={onClose}
          style={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
          {tags.slice(page * 15, (page + 1) * 15).map((tag, index) => (
            <WbTag
              tag={tag}
              style={{ maxWidth: '100%' }}
              key={index}
              kind={kind}
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions style={{ padding: '8px 16px' }}>
        <TablePagination
          component="div"
          count={tags.length}
          page={page}
          onPageChange={(e, v) => {
            handleChange(e, v);
          }}
          rowsPerPage={15}
          onRowsPerPageChange={() => {}}
          rowsPerPageOptions={[]}
        />
      </DialogActions>
    </Dialog>
  );
};

WbTagsModal.defaultProps = {
  maxWidth: 'lg',
};
